import { useState } from 'react';
import { Navigate, useNavigate } from '@tanstack/react-router';
import { useAuth } from 'app/javascript/contexts/AuthContext';
import { ROUTES } from 'app/javascript/constants/routes';
import { Button } from 'app/javascript/components/ui/button';
import { Tabs, TabsList, TabsTrigger, TabsContent } from 'app/javascript/components/ui/tabs';
import OverviewCards from 'app/javascript/components/admin/OverviewCards';
import RecentUsersTable from 'app/javascript/components/admin/RecentUsersTable';
import RecentCompaniesTable from 'app/javascript/components/admin/RecentCompaniesTable';
import FailedPhotosTable from 'app/javascript/components/admin/FailedPhotosTable';

// Owner-only debug dashboard. The check below is UX gating only — the real
// protection is AdminPolicy returning 403 on every /api/v1/admin/* endpoint.
export default function AdminPage() {
  const { currentUser, logout } = useAuth();
  const navigate = useNavigate();
  const [signingOut, setSigningOut] = useState(false);
  const [logoutError, setLogoutError] = useState('');

  const handleLogout = async () => {
    setSigningOut(true);
    setLogoutError('');
    try {
      await logout();
      await navigate({ to: ROUTES.HOME });
    } catch {
      setLogoutError('Não foi possível sair. Tente novamente.');
    } finally {
      setSigningOut(false);
    }
  };

  if (!currentUser?.appAdmin) {
    return <Navigate to={ROUTES.HOME} />;
  }

  return (
    <div className="space-y-8">
      <header className="flex flex-wrap items-start justify-between gap-4">
        <div>
          <h1 className="font-bebas text-4xl tracking-wide text-yellow-400">Admin</h1>
          <p className="text-sm text-muted-foreground">
            Acompanhamento, diagnóstico e recuperação da plataforma.
          </p>
        </div>
        <Button variant="outline" className="min-h-11" onClick={handleLogout} disabled={signingOut}>
          {signingOut ? 'Saindo…' : 'Sair do admin'}
        </Button>
      </header>
      {logoutError && <p role="alert" className="text-sm text-destructive">{logoutError}</p>}
      <OverviewCards />
      <Tabs defaultValue="users" className="space-y-4">
        <TabsList className="h-auto flex-wrap bg-secondary/60">
          <TabsTrigger value="users">Últimos usuários</TabsTrigger>
          <TabsTrigger value="companies">Últimas academias</TabsTrigger>
          <TabsTrigger value="failed_photos">Fotos com problema</TabsTrigger>
        </TabsList>
        <TabsContent value="users">
          <RecentUsersTable />
        </TabsContent>
        <TabsContent value="companies">
          <RecentCompaniesTable />
        </TabsContent>
        <TabsContent value="failed_photos">
          <FailedPhotosTable />
        </TabsContent>
      </Tabs>
    </div>
  );
}
